
















import {
  GelNetworkCodeDTO,
  GelPickupPointInfos
} from "@/model/component.model";
import {
  AddressLocatorDto,
  AddressShipmentDTO,
  ShipmentPackageDTO
} from "@/model/data.model";
import GelService from "@/services/GelService";
import { getShipmentType } from "@/services/Helpers";
import { PriceListService } from "@/services/PriceListService";
import { ShipmentService } from "@/services/ShipmentService";
import store from "../../../vuex/store";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class GelPickupMap extends Vue {
  gelSDKInstance: any = {};
  gelNetworkCodes: GelNetworkCodeDTO[] = [];
  merchantCode = "";
  apiKey = "";

  @Prop({ default: false })
  isReturnOrder: boolean;
  @Prop({})
  initAddress: AddressShipmentDTO;
  @Prop({})
  mbeServiceBusinessId: number;
  @Prop({})
  courierBusinessId: number;
  @Prop({})
  courierServiceBusinessId: number;
  @Prop({})
  package: ShipmentPackageDTO;
  @Prop({})
  weight: number;
  @Prop({})
  macroareaFrom: string;

  created() {
    this.loadMerchantCode().then(() => {
      this.gelParametersChange();
    });
  }

  async loadMerchantCode() {
    const response = await ShipmentService.molUserCode(
      this.$store.getters.user.username
    );
    const molUser = response.find(
      (el: any) => el.username === this.$store.getters.user.username
    );
    if (molUser) {
      const res = (await ShipmentService.molUserAccount(
        molUser.idCodeConfiguration
      )) as any;
      const courierAccount = res;
      if (courierAccount) {
        const apiKeyItem = courierAccount.additionalParameters.find(
          (item: any) => item.key === "gel_client_key"
        );
        if (apiKeyItem) {
          this.apiKey = apiKeyItem.value;
        }
        const merchantCodeItem = courierAccount.additionalParameters.find(
          (item: any) => item.key === "gel_merchant_code"
        );
        if (merchantCodeItem) {
          this.merchantCode = merchantCodeItem.value;
        }
      }
    }
  }

  initGelMap() {
    if (this.apiKey && this.merchantCode) {
      window.console.log(
        `GEL map parameters`,
        `urelEndUser: ${
          this.$store.getters.envs.isProduction
            ? "https://platform.gelproximity.com/gel-enduser-client/"
            : "https://qa-platform.gelproximity.com/gel-enduser-client/"
        }`,
        `merchantCode: ${this.merchantCode}`,
        `apiKey: ${this.apiKey}`,
        `reference: orderRef-x8epO`,
        `redirectMode: POST`,
        `isReturnOrder: ${this.isReturnOrder}`,
        `networks: ${this.selectedNetworkCodesList}`,
        `locale: ${this.localeID}`,
        `width: ${this.package.width}`,
        `height: ${this.package.height}`,
        `depth: ${this.package.depth}`
      );
      this.gelSDKInstance = new window.GelSDK({
        urlEndUser: this.$store.getters.envs.isProduction
          ? "https://platform.gelproximity.com/gel-enduser-client/"
          : "https://qa-platform.gelproximity.com/gel-enduser-client/",
        merchantCode: this.merchantCode,
        //MER_000114
        apiKey: this.apiKey,
        //1febd15e-75ae-4703-bbbd-7f89a542cc6d
        reference: "orderRef-x8epO",
        redirectMode: "POST",
        isReturnOrder: this.isReturnOrder,
        networks: this.selectedNetworkCodesList,
        locale: this.localeID,
        width: this.package.width,
        height: this.package.height,
        depth: this.package.depth
      });
    }
  }

  /* 	@Watch('gelNetworkCode', {deep: true, immediate: true})
	@Watch('courierSelected', {deep: true, immediate: true})
	onSelectedNetworkCodesChange(){
		this.initGelMap();
	} */

  @Watch("mbeServiceBusinessId", {})
  @Watch("courierBusinessId")
  @Watch("courierServiceBusinessId", {})
  @Watch("package", { deep: true })
  gelParametersChange() {
    GelService.prototype
      .getNetworks(
        this.mbeServiceBusinessId,
        this.courierBusinessId,
        this.courierServiceBusinessId,
        this.merchantCode,
        this.weight
      )
      .then(res => {
        this.gelNetworkCodes = res;
        this.$emit("updateNetworkCodes", res);
        this.initGelMap();
      });
  }

  openMap() {
    const errors = [];
    if (
      this.package.width === 0 ||
      this.package.height === 0 ||
      this.package.depth === 0
    ) {
      errors.push(this.$t("gel_missing_parameters"));
    }
    if (this.weight <= 0 || this.weight > 20) {
      errors.push(this.$t("gel_invalid_weight"));
    }
    if (errors.length > 0) {
      this.$alerts.danger(errors.join("<br/>"));
    } else {
      this.gelSDKInstance.createUIModal({
        callbackOk: (data: GelPickupPointInfos) =>
          this.onPickupPointSelected(data),
        callbackKo: () => this.onModalClose()
      });
    }
  }

  onModalClose() {}

  get selectedNetworkCodesList() {
    return this.gelNetworkCodes.map((item: any) => item.code);
  }

  onPickupPointSelected(data: GelPickupPointInfos) {
    PriceListService.getMbeServices().then(res => {
      const gelService = res.find(
        el => el.idMBEBusiness === this.mbeServiceBusinessId
      );
      if (gelService) {
        const gelServiceId = gelService.idMBEService;
        const visibilities = this.$store.getters[
          "customer/courierVisibilityConfig"
        ];

        let macroareaTo = "";
        store.cache
          .dispatch("shipment/getMacroareaForContact", {
            zipCode: data.zipCode,
            countryId: data.country
          })
          .then(value => {
            macroareaTo = value;
            const shipType = getShipmentType(this.macroareaFrom, macroareaTo);

            const isEnabled = visibilities.some(
              el =>
                el.mbeServiceId === gelServiceId && el.shipmentType === shipType
            );

            if (isEnabled) {
              const addressData = {
                address: data.address,
                province: "",
                city: data.city,
                countryId: data.country,
                zipCode: data.zipCode,
                pickupExemption: false,
                flavour: "NONE",
                ltz: false,
                gelPudoPointId: data.code,
                gelNetworkCode: data.networkCode,
                locatorName: data.description,
                distance: 0,
                unitOfMisure: "",
                phoneNumbers: [],
                latitude: data.lat,
                longitude: data.lon
              } as AddressLocatorDto;
              this.$emit("gelPointSelected", addressData);
            } else {
              this.$alerts.danger(this.$t("ship_type_not_available"));
            }
          });
      } else {
        console.error("Missing mbeServiceId");
      }
    });
  }

  get localeID() {
    const locales = {
      it: "it_IT",
      fr: "fr_FR",
      en: "en_GB",
      de: "de_DE",
      es: "es_ES",
      pl: "pl_PL"
    } as any;

    return locales[this.$store.getters.language] || "en_GB";
  }
}
